import axios from "axios"

export const addRecord = async (formData) => {
	return await axios.post(`${process.env.REACT_APP_BACK_URL}/record`, formData)
}

export const addRecordBiovelox = async (formData) => {
	return await axios.post(`${process.env.REACT_APP_BACK_URL}/record-biovelox`, formData)
}

export const addRecordCryotherapie = async (formData) => {
	return await axios.post(`${process.env.REACT_APP_BACK_URL}/record-cryotherapie`, formData)
}

export const addPrescription = async (formData) => {
	return await axios.post(`${process.env.REACT_APP_BACK_URL}/prescription-only`, formData)
}

export const filterPrescribers = async (inputValue) => {
	return (await axios.get(`${process.env.REACT_APP_BACK_URL}/prescribers/${inputValue}`)).data.prescribers
}

export const filterArticles = async (inputValue) => {
	return (await axios.get(`${process.env.REACT_APP_BACK_URL}/articles/${inputValue}`)).data.articles
}

export const filterOrganismeAMC = async (inputValue) => {
	return (await axios.get(`${process.env.REACT_APP_BACK_URL}/organisms-amc/${inputValue}`)).data.organisms
}
